import { TagTabProps } from "@components/Tags/TagNonprofitsTab";
import { Feed } from "@components/feed";
import React, { useCallback } from "react";

import { FeedPage } from "@every.org/common/src/entity/types";
import { ListParams } from "@every.org/common/src/routes/index";
import {
  CAUSE_FEED_MAX_PAGE_NUM,
  CAUSE_FEED_PAGE_SIZE,
} from "@every.org/common/src/routes/publicCached";

import { fetchTagGifts } from "src/context/DonationsContext/actions";

export const TagGiftsTab: React.FCC<TagTabProps> = ({
  tagName,
  initialFeedItems,
  onNoMoreItems,
}) => {
  const loadMoreItems = useCallback(
    async ({ take, skip }: ListParams) => {
      const page = Math.min(
        Math.floor((skip + take - 1) / CAUSE_FEED_PAGE_SIZE),
        CAUSE_FEED_MAX_PAGE_NUM
      );
      const { items } = await fetchTagGifts(tagName, page);
      const hasMore =
        items.length === CAUSE_FEED_PAGE_SIZE && page < CAUSE_FEED_MAX_PAGE_NUM;
      return {
        items,
        hasMore,
      };
    },
    [tagName]
  );

  return (
    <Feed
      initialItems={initialFeedItems}
      page={FeedPage.TAG_GIFTS}
      loadMoreItems={loadMoreItems}
      onNoMoreItems={onNoMoreItems}
    />
  );
};
